import { useTranslate } from "@similarweb/i18n-provider";
import Sentry from "@similarweb/sentry-logger";

import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import { useHasManagementAccess } from "app/pages/sales-intelligence/pages/management/hooks/useHasManagementAccess";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import integrationTrackingService from "app/pages/sales-intelligence/services/tracking/integrationTrackingService";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import { CRM_INTEGRATION_HOOK_NAME } from "../../constants/crm";
import CRMConnectButton from "../CRMConnectButton/CRMConnectButton";
import IntegrationButtonWrapperWithFeatureRequest from "../integration-button/IntegrationButtonWrapperWithFeatureRequest";

interface IProps {
    integrationName: Integration;
}

const CRMGatewayButton = ({ integrationName }: IProps): React.ReactElement => {
    const { translate } = useTranslate();

    const [hasAccess] = useHasManagementAccess(integrationName);

    const isCrmIntegrationsEnabled = salesSettingsHelper.isCrmIntegrationsEnabled();

    const handleUpgradeClick = () => {
        if (CRM_INTEGRATION_HOOK_NAME[integrationName]) {
            return;
        }

        Sentry.error(
            `CRM Gain access: non-existent CRM integration name (${integrationName})`,
            new Error("Not handled CRM integration name"),
        );
    };

    return (
        <IntegrationButtonWrapperWithFeatureRequest
            hookId={CRM_INTEGRATION_HOOK_NAME[integrationName]}
            dataAutomationNameSpace="crm-integration-button"
            upgradeButtonText={translate("si.common.contact_us")}
            featureName={integrationName}
            hasAccess={hasAccess}
            isEnabled={isCrmIntegrationsEnabled}
            onUpgradeClick={handleUpgradeClick}
        >
            <CRMConnectButton
                integrationName={integrationName}
                onConnect={() => manageIntegrationsTrackingService.trackGatewayConnect(integrationName)}
                onManage={() => manageIntegrationsTrackingService.trackCrmManage(integrationName)}
                onApproveTerms={() => manageIntegrationsTrackingService.trackCrmApproveTerms(integrationName)}
                onDenyTerms={() => integrationTrackingService.trackIntegrationDeny(integrationName)}
            />
        </IntegrationButtonWrapperWithFeatureRequest>
    );
};

export default CRMGatewayButton;
